module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-height": "100vh",
      "overflow-y": "scroll"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n              Update the fields which need change\n            ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n              Change Author Display Name\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.displayName),
      expression: "passedObject.displayName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.displayName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "displayName", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change About author - Biographical information\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.aboutAuthor),
      expression: "passedObject.aboutAuthor"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.aboutAuthor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "aboutAuthor", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change Author Tagline\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.authorTagline),
      expression: "passedObject.authorTagline"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.authorTagline)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "authorTagline", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change SEO Title for author page\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.authorSeoTitle),
      expression: "passedObject.authorSeoTitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.authorSeoTitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "authorSeoTitle", $event.target.value)
      }
    }
  })]), _vm._v("\n              Change SEO Description for author page\n              "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.passedObject.authorSeoDesc),
      expression: "passedObject.authorSeoDesc"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.passedObject.authorSeoDesc)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.passedObject, "authorSeoDesc", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.passedObject.customAvatar) ? _c('div', [_vm._v("\n                Current Author Image\n                "), _c('img', {
    staticStyle: {
      "width": "50px",
      "height": "auto"
    },
    attrs: {
      "src": _vm.passedObject.customAvatar
    }
  })]) : _c('div', [_vm._v("The Author does not have custom image")]), _vm._v("\n              Upload new image to change author image\n              "), _c('ic-firebase-upload', {
    attrs: {
      "path": "images",
      "max-files": "1",
      "getFileName": _vm.getFileName,
      "storage": _vm.storage
    },
    on: {
      "uploaded": _vm.onUploadedAuthorImage,
      "upload": _vm.onUpload,
      "delete": _vm.onDelete
    }
  })])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [_c('button', {
    staticClass: "modal-default-button",
    on: {
      "click": _vm.editAuthor
    }
  }, [_vm._v("\n                UPDATE AUTHOR\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "modal-default-button cancel-delete-button",
    on: {
      "click": _vm.closeTheModal
    }
  }, [_vm._v("\n                CANCEL\n              ")])])], 2)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a3699676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAuthoredit.vue
// module id = 677
// module chunks = 1